"use strict";
function parseSalary(salaryStr) {
    return Number(salaryStr.replace(/[^0-9.-]/g, ""));
}
function sortList(list) {
    var items = Array.from(list.querySelectorAll("li"));
    items.sort(function(a, b) {
        var salaryA = parseSalary(a.dataset.salary);
        var salaryB = parseSalary(b.dataset.salary);
        return salaryB - salaryA;
    });
    items.forEach(function(item) {
        return list.appendChild(item);
    });
}
function getEmployees(list) {
    var items = Array.from(list.querySelectorAll("li"));
    return items.map(function(item) {
        return {
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: parseSalary(item.dataset.salary),
            age: Number(item.dataset.age)
        };
    });
}
var employeesList = document.querySelector("ul");
sortList(employeesList);
getEmployees(employeesList);

//# sourceMappingURL=index.0b31f580.js.map
